module.exports = __webpack_public_path__ + "img/polisoft-logo.8c7426b1.svg";